import { render, staticRenderFns } from "./StrategyOverview.vue?vue&type=template&id=4b6c569a&"
import script from "./StrategyOverview.vue?vue&type=script&lang=js&"
export * from "./StrategyOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports